import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbAccordionModule } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule, TranslateService } from '@ngx-translate/core';

import { MaterialCaptchaStepsComponent } from './components/material-captcha/material-captcha-step/material-captcha-steps.component';
import { MaterialCaptchaComponent } from './components/material-captcha/material-captcha.component';
import { MaterialDonutChartComponent } from './components/material-donut-chart/material-donut-chart.component';
import { MaterialFeedbackComponent } from './components/material-feedback/material-feedback.component';
import { MaterialJcvdComponent } from './components/material-jcvd/material-jcvd.component';
import { MaterialSpinnerComponent } from './components/material-spinner/material-spinner.component';
import { MaterialVisitorHomeAccordionModuloComponent } from './components/material-visitor-home-accordion-modulo/material-visitor-home-accordion-modulo.component';
import { MaterialVisitorHomeAccordionsComponent } from './components/material-visitor-home-accordion-modulo/material-visitor-home-accordions/material-visitor-home-accordions.component';
import { MaterialVisitorHomeMultipleEntryComponent } from './components/material-visitor-home-accordion-modulo/material-visitor-home-multiple-entry/material-visitor-home-multiple-entry.component';
import { MaterialVisitorHomeWidgetsComponent } from './components/material-visitor-home-accordion-modulo/material-visitor-home-widgets/material-visitor-home-widgets.component';
import { MaterialVisitorHomeComponent } from './components/material-visitor-home/material-visitor-home.component';
import { MaterialAlertComponent } from './components/ob1/material-alert/material-alert.component';
import { MaterialBubbleComponent } from './components/ob1/material-bubble/material-bubble.component';
import { MaterialCardListComponent } from './components/ob1/material-card-list/material-card-list.component';
import { MaterialItemListComponent } from './components/ob1/material-item-list/material-item-list.component';
import { MaterialSnackBarComponent } from './components/ob1/material-snack-bar/material-snack-bar.component';
import { MaterialButtonProgressBarDirective } from './directives/material-button-progressBar.directive';
import { MaterialCustomMaskDirective } from './directives/material-custom-mask.directive';
import { MaterialDisabledActionDirective } from './directives/material-disabled-action.directive';
import { MaterialPushTrackerDirective } from './directives/material-push-tracker.directive';
import { MaterialSoshSignatureDirective } from './directives/material-sosh-signature.directive';
import { MaterialTargetDirective } from './directives/material-target.directive';
import { materialTranslationFr } from './i18n/fr';

@NgModule({
    imports: [
        CommonModule,
        NgbAccordionModule,
        MaterialCustomMaskDirective,
        MaterialDisabledActionDirective,
        TranslateModule,
        ReactiveFormsModule,
        FormsModule,
        MaterialAlertComponent,
        MaterialBubbleComponent,
        MaterialButtonProgressBarDirective,
        MaterialCaptchaComponent,
        MaterialCaptchaStepsComponent,
        MaterialCardListComponent,
        MaterialDonutChartComponent,
        MaterialFeedbackComponent,
        MaterialItemListComponent,
        MaterialJcvdComponent,
        MaterialPushTrackerDirective,
        MaterialSnackBarComponent,
        MaterialSoshSignatureDirective,
        MaterialSpinnerComponent,
        MaterialTargetDirective,
        MaterialVisitorHomeAccordionModuloComponent,
        MaterialVisitorHomeAccordionsComponent,
        MaterialVisitorHomeComponent,
        MaterialVisitorHomeMultipleEntryComponent,
        MaterialVisitorHomeWidgetsComponent,
    ],
    exports: [
        MaterialAlertComponent,
        MaterialBubbleComponent,
        MaterialButtonProgressBarDirective,
        MaterialCaptchaComponent,
        MaterialCardListComponent,
        MaterialCustomMaskDirective,
        MaterialDisabledActionDirective,
        MaterialDonutChartComponent,
        MaterialFeedbackComponent,
        MaterialItemListComponent,
        MaterialJcvdComponent,
        MaterialPushTrackerDirective,
        MaterialSnackBarComponent,
        MaterialSoshSignatureDirective,
        MaterialSpinnerComponent,
        MaterialTargetDirective,
        MaterialVisitorHomeAccordionModuloComponent,
        MaterialVisitorHomeComponent,
    ],
})
export class EcmMaterialModule {
    private static translationLoaded = false;

    public constructor(translate: TranslateService) {
        if (!EcmMaterialModule.translationLoaded) {
            translate.setTranslation('fr', materialTranslationFr, true);
            EcmMaterialModule.translationLoaded = true;
        }
    }
}
